import useTemplate from "../../../../hooks/useTemplate";
import React, { useMemo, useRef } from "react";
import useResizeObserver from "../../../../hooks/useResizeObserver";
import { createInstance } from "../../../../Providers/TemplateInstanceProvider";
import { getBoxSize } from "../../../../utils";
import DrawTemplate from "../../../../components/Template/DrawTemplate";

const TemplateProductPreview = ({
  templateUuid,
  userResources,
  verticalAlign,
  containerSize,
  year,
}) => {
  const [template] = useTemplate(templateUuid);
  const containerRef = useRef();
  const cs = useResizeObserver(containerRef);

  console.log("Template product preview", userResources);
  const csSize = useMemo(() => {
    if (containerSize) {
      return containerSize;
    }

    console.log("The size is", cs);
    return {
      width: cs.width,
      height: cs.width,
    };
  }, [cs, containerSize]);

  const templateInstance = useMemo(() => {
    if (!template) {
      return null;
    }

    const inst = createInstance(template);

    const instance = {
      ...inst,
      year: year || inst.year,
      resources: {
        ...inst.resources,
        ...userResources,
      },
    };

    return instance;
  }, [template, userResources, cs]);

  if (!templateInstance) {
    console.log("Instance not loaded");
    return null;
  }

  console.log("Instance loaded", csSize);

  const style = {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    alignItems: verticalAlign == "center" ? "center" : "flex-end",
  };

  return (
    <div style={style} ref={containerRef}>
      <TemplateContainer templateInstance={templateInstance} size={csSize} />
    </div>
  );
};

const TemplateContainer = ({ templateInstance, size }) => {
  //const classes = useStyles();

  const [cSize, style] = useMemo(() => {
    const horizontalPadding = 6;
    const verticalPadding = 6;

    const template = templateInstance.template;

    let visibleSize = {
      width: template.dimensions.width,
      height: template.dimensions.height,
    };

    if (template.trimBox) {
      visibleSize = {
        width: template.trimBox.width,
        height: template.trimBox.height,
      };
    }

    const cSize = getBoxSize("fit-in", visibleSize, {
      width: size.width - horizontalPadding * 2,
      height: size.height - verticalPadding * 2,
    });

    const style = {
      width: cSize.width + "px",
      height: cSize.height + "px",
      position: "relative",
    };
    return [cSize, style];
  }, [size, templateInstance]);

  console.log("The template container", style);

  return (
    <div style={style}>
      <DrawTemplate
        templateInstance={templateInstance}
        containerSize={cSize}
      />
    </div>
  );
};

export default TemplateProductPreview;
